import {ReactNode} from "react";
import {i18n} from "i18next";

import {changeLanguage} from "../../../../../utils/change_language";
import {chartsRoutes} from "../routing/charts_routes";

export const staticLinks = (
    i18n: i18n
): {
    href: string;
    title: string;
    rel?: string;
    children: string | ReactNode;
    target?: string;
    external?: boolean;
    onClick?: () => void;
}[] => [
    {
        href: chartsRoutes[i18n.language].newshub.marketInformation.root,
        title: "BIG DATA Insight",
        children: "BIG DATA Insight"
    },
    {
        href: chartsRoutes[i18n.language].contact,
        title: i18n.t("nav.contact"),
        children: i18n.t("nav.contact").toString()
    },
    {
        href: chartsRoutes.pl.pressOffice.root,
        title: i18n.t("nav.press_office"),
        children: i18n.t("nav.press_office").toString(),
        onClick: changeLanguage
    },
    {
        href: chartsRoutes[i18n.language].pricing,
        title: i18n.t("nav.pricing"),
        children: i18n.t("nav.pricing").toString()
    },
    {
        href: chartsRoutes[i18n.language].terms,
        title: i18n.t("nav.terms_of_service"),
        children: i18n.t("nav.terms_of_service").toString(),
        target: "_blank",
        external: true
    },

    {
        href: chartsRoutes[i18n.language].privacyPolicy,
        title: i18n.t("nav.privacy_policy"),
        children: i18n.t("nav.privacy_policy").toString(),
        target: "_blank",
        external: true
    },
    {
        href: chartsRoutes[i18n.language].faq,
        title: i18n.t("nav.faq"),
        children: i18n.t("nav.faq").toString()
    }
];
